import Vue from 'vue'
import axios from 'axios'
import {VueAxios} from './axios'


/**
 * 【指定 axios的 baseURL】
 * 如果手工指定 baseURL: '/jeecg-boot'
 * 则映射后端域名，通过 vue.config.js
 * @type {*|string}
 */
let apiBaseUrl = process.env.baseURL
// console.log("apiBaseUrl= ",apiBaseUrl)
// 创建 axios 实例
const service = axios.create({
  // baseURL: '/api',
  baseURL: apiBaseUrl, // api base_url
  timeout: 15000 // 请求超时时间
})

const err = (error) => {
  //alert(error.code);
  if(error.code == 'ECONNABORTED' || 'ERR_NETWORK'==error.code){
    localStorage.setItem("network", false);
  }
  return Promise.reject(error.response.data ? error.response.data : error.response)
};

// request interceptor
service.interceptors.request.use(config => {
  config.params = {
    _t: Date.parse(new Date()) / 1000,
    ...config.params
  }
  const accessToken = localStorage.getItem("X_AccessToken");
  if (accessToken) {
    config.headers = Object.assign(config.headers, {
      "X-Access-Token": accessToken
    })
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
  // console.log('object-response.data',response,response.headers["content-disposition"]);
  // 导出文件流的数据返回
  if(response.request.responseType =='blob'){
    return response.data
  }
  if (!response.data.success) {
    // Vue.prototype.$Jmessage.error(response.data.message)
    Vue.prototype.$Jnotification.error({message: '系统提示',description:response.data.code==400?response.data.message:'服务繁忙，请稍后再试',duration: 4})
    return Promise.reject(response.data);
  } else {
    return response.data;
  }
}, err)

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js